import { css } from '@emotion/react';
import { colors } from '@modernanimal/common';
import FTRegolaNeueBold from '@modernanimal/common/src/fonts/FTRegolaNeue-Bold.otf';
import FTRegolaNeueMedium from '@modernanimal/common/src/fonts/FTRegolaNeue-Medium.otf';
import FTRegolaNeueRegular from '@modernanimal/common/src/fonts/FTRegolaNeue-Regular.otf';

import { fontFamily } from './fonts';

export default css`
    @font-face {
        font-family: ${fontFamily.base};
        src: url('${FTRegolaNeueRegular}') format('truetype');
    }
    @font-face {
        font-family: ${fontFamily.baseMedium};
        src: url('${FTRegolaNeueMedium}') format('truetype');
    }
    @font-face {
        font-family: ${fontFamily.baseBold};
        src: url('${FTRegolaNeueBold}') format('truetype');
    }

    body, textarea, input {
        line-height: unset;
        font-size: unset;
        font-family: ${fontFamily.base};
        margin: 0;
        #claude-header {
            position: sticky;
            top: 0;
            z-index: 10;
        }
    }
    label, .label {
        color: ${colors.GREY_3};
        font-family: ${fontFamily.baseMedium};
        font-size: 12px;
        line-height: 15px;
        &.dark {
            color: ${colors.GREY_1};
        }
    }
    ul {
        padding: 0;
        margin: 0;
        font-family: ${fontFamily.base};
        li {
            list-style-type: none;
            margin-bottom: 8px;
        }
    }
    ol {
        font-family: ${fontFamily.base};
    }
    a, .link {
        color: ${colors.PRIMARY_PERIWINKLE};
        font-family: ${fontFamily.base};
        text-decoration-line: underline;
        cursor: pointer;
    }
    textarea, input {
        line-height: unset;
        font-size: unset;
        font-family: ${fontFamily.base};
    }
    button {
        font-family: ${fontFamily.base};
        -webkit-appearance: none;
        cursor: pointer;
        border: none;
        background-color: transparent;
        padding: 0;

        &:disabled {
            cursor: default;
            opacity: 0.3;
        }
    }
    p, h1, h2, h3, h4 {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: normal;
    }

    /* Mobile calendar navigation improvements */
    @media (max-width: 736px) {
        .react-calendar__navigation__arrow {
            padding: 0 16px !important;
        }
    }
`;
